import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "network-select-label"
}
const _hoisted_2 = { class: "ml-2 w-full text-black hover:text-white dark:text-white capitalize network-name" }
const _hoisted_3 = { class: "flex overflow-hidden flex-col w-44 rounded-lg" }
const _hoisted_4 = { class: "py-2 px-3 text-sm font-medium text-black dark:text-white whitespace-nowrap bg-gray-50 dark:bg-gray-800 border-b dark:border-gray-900" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "ml-1 font-medium text-black dark:text-white" }

import { computed, ref } from 'vue';

import useBreakpoints from '@/composables/useBreakpoints';
import ConfigService from '@/services/config/config.service';

export interface NetworkOption {
  id: string;
  name: string;
  subdomain?: string;
  key?: string;
}

// SERVICES

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const configService = new ConfigService();

// COMPOSABLES
const { upToLargeBreakpoint, isDesktop } = useBreakpoints();

const networks = ref([
  {
    id: 'ethereum',
    name: 'Ethereum',
    subdomain: 'app',
    key: '1',
  },
  {
    id: 'polygon',
    name: 'Polygon',
    subdomain: 'polygon',
    key: '137',
  },
  {
    id: 'arbitrum',
    name: 'Arbitrum',
    subdomain: 'arbitrum',
    key: '42161',
  },
]);

const appNetworkSupported = networks.value
  .map(network => network.key)
  .includes(configService.network.key);

const activeNetwork = computed(() =>
  networks.value.find(network => {
    if (!appNetworkSupported && network.id === 'ethereum') return true;
    return isActive(network);
  })
);

// METHODS
function iconSrc(network: NetworkOption): string {
  return require(`@/assets/images/icons/networks/${network.id}.svg`);
}

function appUrl(network: NetworkOption): string {
  return `https://${network.subdomain}.balancer.fi`;
}

function isActive(network: NetworkOption): boolean {
  if (!appNetworkSupported && network.id === 'ethereum') return true;
  return configService.network.key === network.key;
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Chain"))
      : _createCommentVNode("", true),
    _createVNode(_component_BalPopover, {
      class: "bg-gray-50 dark:bg-gray-700 rounded",
      position: _unref(isDesktop) ? 'above' : 'below',
      style: _normalizeStyle({ transform: 'translateX(-50%)' })
    }, {
      activator: _withCtx(() => [
        _createVNode(_component_BalBtn, {
          color: "white",
          size: _unref(upToLargeBreakpoint) ? 'md' : 'sm'
        }, {
          default: _withCtx(() => [
            (_unref(activeNetwork))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(activeNetwork).name), 1),
                  _createVNode(_component_BalIcon, {
                    name: "chevron-down",
                    size: "sm",
                    class: "ml-2"
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('networkSelection')) + ": ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(networks.value, (network) => {
            return (_openBlock(), _createElementBlock("a", {
              key: network.id,
              href: appUrl(network),
              class: "flex justify-between items-center p-3 hover:bg-gray-50 dark:hover:bg-gray-850 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: iconSrc(network),
                  alt: network.name,
                  class: "mr-2 w-6 h-6 rounded-full"
                }, null, 8, _hoisted_7),
                _createElementVNode("span", _hoisted_8, _toDisplayString(network.name), 1)
              ])
            ], 8, _hoisted_5))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["position", "style"])
  ], 64))
}
}

})